(function () {
    'use strict';

    angular.module("imApp").factory("mieTablesService", ['$ihttp', function ($ihttp) {
        let service = {
            updateGrid: function (setting) {
                return $ihttp.post({
                    method: 3598,
                    parameters: setting || {}
                });
            }
        };

        return service;
    }]);
})();
